// extracted by mini-css-extract-plugin
export var linkText = "_pj-0";